<div class="mt-3">
    <div class="row">
        <div class="col-md-1">
            <h1>Users</h1>
        </div>
        <div class="offset-5 col-md-6 col-xl-6 ">
            <div class="row d-flex justify-content-end">
                <div class="col-md-5 col-xl-5  d-flex justify-content-end headermargin">
                    <div class="form-group has-search">
                        <span class="icon-ic_search form-control-search"></span>
                        <input class="form-control frontIcon searchtext" #userame placeholder="Search by user name" autocomplete="off">
                    </div>
                    <button (click)="SearchByUser(userame.value)" class="button ml-3 mr-auto" type="button">
                        Search
                    </button>
                    <div class="separator"></div>
                </div>
                <div class="col-md-4 col-xl-4 d-flex justify-content-end">
                  
                    <button (click)="ResetFilters()" class="button" type="button">
                        Reset
                    </button>
                    <button (click)="addUser()" class="button blue" type="button">
                        Add User
                    </button>
                </div>
              
            
          </div>
        </div>
      </div>
      
      </div>

      
<!-- <div class="app-sub-header" (click)="hideDropdowns()">
    <div class="wrapper">
        <h1 class="state-title">Users</h1>
        <div class="typeahead-wrap">
            <i class="icon-ic_search"></i>
            <input class="lookup-input" #userame placeholder="Search by user name">

        </div>
        <div class="button-section">
            <button (click)="SearchByUser(userame.value)" class="button" type="button">
                Search
            </button>
            <button (click)="ResetFilters()" class="button" type="button">
                Reset
            </button>
            <button (click)="addUser()" class="button blue" type="button">
                Add User
            </button>
        </div>

    </div>
</div> -->